import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Edit, Trash2, Calendar } from 'lucide-react';
import { LoadingState, PageShell, EmptyState } from '@/components/shared';
import { RaceSeriesManagerViewProps } from './raceseriesmanager.props';
import RaceSeriesFormDialog from './raceseriesmanager.form';

const RaceSeriesManagerView: React.FC<RaceSeriesManagerViewProps> = ({
  seriesList,
  loading,
  isDialogOpen,
  setIsDialogOpen,
  editingSeries,
  formData,
  setFormData,
  openCreate,
  openEdit,
  handleSubmit,
  handleDelete,
  deleteTarget,
  setDeleteTarget,
  confirmDelete,
}) => {
  return (
    <PageShell>
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Серии на трки</h2>
          <p className="text-gray-600">Групирајте повеќе настани во една серија (едиции)</p>
        </div>
        <RaceSeriesFormDialog
          isDialogOpen={isDialogOpen}
          setIsDialogOpen={setIsDialogOpen}
          editingSeries={editingSeries}
          formData={formData}
          setFormData={setFormData}
          openCreate={openCreate}
          handleSubmit={handleSubmit}
          deleteTarget={deleteTarget}
          setDeleteTarget={setDeleteTarget}
          confirmDelete={confirmDelete}
        />
      </div>

      {loading ? (
        <LoadingState />
      ) : seriesList.length === 0 ? (
        <EmptyState message="Нема серии. Креирајте серија за да групирате повеќе едиции на ист настан." inCard />
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {seriesList.map((series) => (
            <Card key={series.id}>
              <CardHeader className="pb-2">
                <div className="flex items-start justify-between">
                  <CardTitle className="text-lg">{series.name}</CardTitle>
                  <div className="flex gap-1">
                    <Button variant="ghost" size="sm" onClick={() => openEdit(series)}><Edit className="w-4 h-4" /></Button>
                    <Button variant="ghost" size="sm" className="text-red-600 hover:text-red-700" onClick={() => handleDelete(series.id)}><Trash2 className="w-4 h-4" /></Button>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                {series.description && <p className="text-sm text-gray-600 mb-3 line-clamp-2">{series.description}</p>}
                <div className="flex items-center gap-2 text-sm text-gray-500">
                  <Calendar className="w-4 h-4" />
                  <span>{series.races?.length || 0} настани</span>
                </div>
                {series.races && series.races.length > 0 && (
                  <div className="mt-2 flex flex-wrap gap-1">
                    {series.races.map((race) => (
                      <span key={race.id} className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">{race.name}</span>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </PageShell>
  );
};

export default RaceSeriesManagerView;
